<template>
  <div class="contact-page">

    <contact-hero-section
      :fields="contactPageSections.sections.contact_hero_section.fields"
    />

    <contact-divider-section
      :fields="contactPageSections.sections.contact_divider_section.fields"
    />

    <contact-text-section
      :fields="contactPageSections.sections.contact_text_section.fields"
    />

    <contact-info-section
      :fields="contactPageSections.sections.contact_info_section.fields"
      @openPopup="$emit('openPopup', 'ARRIVAL')"
    />

    <contact-divider2-section
      :fields="contactPageSections.sections.contact_divider2_section.fields"
    />

    <!--    disable for couple off weeks-->
    <contact-text2-section
      v-if="false"
      :fields="contactPageSections.sections.contact_text_2_section.fields"
    />

    <contact-contact-section
      :fields="contactPageSections.sections.contact_contact_section.fields"
    />

  </div>
</template>

<script>
import ContactHeroSection from "/seu-frontend/sections/contact-page/ContactHeroSection";
import ContactContactSection from "/seu-frontend/sections/contact-page/ContactCallToActionSection";
import DividerSection from "/seu-frontend/sections/general/DividerSection";
import ContactTextSection from "/seu-frontend/sections/contact-page/ContactTextSection";
import ContactText2Section from "/seu-frontend/sections/contact-page/ContactText2Section";
import ContactDividerSection from "/seu-frontend/sections/contact-page/ContactDividerSection";
import ContactDivider2Section from "/seu-frontend/sections/contact-page/ContactDivider2Section";
import ContactInfoSection from "/seu-frontend/sections/contact-page/ContactInfoSection";

export default {
  name: "ContactPage",
  components: {
    ContactInfoSection,
    ContactDivider2Section,
    ContactDividerSection,
    ContactText2Section,
    ContactTextSection,
    DividerSection,
    ContactContactSection,
    ContactHeroSection,
  },

  computed: {
    contactPageSections() {
      return require(`../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/contactPage`).default;
    }
  },

  metaInfo() {
    return {
      title: this.contactPageSections.title,
    }
  }
}
</script>

<style lang="scss">
@import "ContactPage.scss";
</style>
